var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35771",
    "data-name": "Group 35771",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 33.132,
    viewBox: "0 0 24 33.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.888,
    cy: 0.083,
    r: 0.773,
    gradientTransform: "translate(0 -0.06) scale(1 1.648)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#d045e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#7c22e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d08a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#bab4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4f4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.232,
    y1: 0.163,
    x2: 0.951,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906fe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.42,
    y1: 0.658,
    x2: 0.131,
    y2: 0.898,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.181,
    y1: 0.314,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.677,
    y1: 0.052,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35811",
    x: 12.511,
    y: 12.238,
    width: 10.513,
    height: 10.513,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35816",
    "data-name": "Path 35816",
    d: "M174.648,165.663a14.866,14.866,0,0,1-1.312,1.43,12.082,12.082,0,0,1-14.9-16.154,12.083,12.083,0,0,1,16.209,14.724Z",
    transform: "translate(-157.5 -150)",
    fill: "#fdcb6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35759",
    "data-name": "Group 35759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "first-place",
    transform: "translate(4.868 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35725",
    "data-name": "Group 35725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35789",
    "data-name": "Path 35789",
    d: "M198.179,12.384l-2.029,5.1a.575.575,0,0,1-.535.363H188.8a.575.575,0,0,1-.535-.788l2.389-6.011q.57-.046,1.152-.046A14.159,14.159,0,0,1,198.179,12.384Z",
    transform: "translate(-184.795 -9.996)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35790",
    "data-name": "Path 35790",
    d: "M160.816,90h-8.5a1.818,1.818,0,0,0-1.821,1.811v2.415a1.818,1.818,0,0,0,1.821,1.811h8.5a1.818,1.818,0,0,0,1.821-1.811V91.811A1.818,1.818,0,0,0,160.816,90Zm.607,4.226a.606.606,0,0,1-.607.6h-8.5a.606.606,0,0,1-.607-.6V91.811a.606.606,0,0,1,.607-.6h8.5a.606.606,0,0,1,.607.6Z",
    transform: "translate(-149.355 -84.552)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35791",
    "data-name": "Path 35791",
    d: "M141.845,7.849H133.8a.6.6,0,0,1-.561-.381L130.6.827A.6.6,0,0,1,131.163,0h7.153a.6.6,0,0,1,.561.381Z",
    transform: "translate(-130.558 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35792",
    "data-name": "Path 35792",
    d: "M136.259,7.849H133.8a.6.6,0,0,1-.561-.381L130.6.827A.6.6,0,0,1,131.163,0h1.424L135.5,7.336A.814.814,0,0,0,136.259,7.849Z",
    transform: "translate(-130.534 0)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35735",
    "data-name": "Group 35735",
    transform: "translate(0 8.752)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2333",
    "data-name": "Ellipse 2333",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(0 0.38)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_9",
    "data-name": "Exclusion 9",
    d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19Zm0-16.249A6.75,6.75,0,1,0,16.251,9.5,6.756,6.756,0,0,0,9.5,2.751Z",
    transform: "translate(2.546 2.881)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35808",
    "data-name": "Path 35808",
    d: "M174.648,165.663c-.406.5-.044.923-1.312,1.43a9.617,9.617,0,0,1-3.76.6,12.082,12.082,0,0,1-11.136-16.751,12.083,12.083,0,0,1,16.209,14.724Z",
    transform: "translate(-151.189 -149.62)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_179",
    "data-name": "Union 179",
    d: "M.908,9.725A.908.908,0,0,1,0,8.816a3.39,3.39,0,0,1,.057-.607l.007.017A3.474,3.474,0,0,1,.775,6.692L3.685,3.115a.763.763,0,0,0,.107-.8.673.673,0,0,0-.6-.431H3.153a1,1,0,0,0-.979,1.02.926.926,0,0,1-.908.945A.926.926,0,0,1,.36,2.907,2.856,2.856,0,0,1,3.153,0c.034,0,.063,0,.1,0a2.486,2.486,0,0,1,2.2,1.552,2.7,2.7,0,0,1-.382,2.779L2.16,7.911c-.011.011-.021.025-.031.039H5.042a.9.9,0,0,1,.764.434l.018-.028a.906.906,0,0,1-.781,1.369Z",
    transform: "translate(9 7.38)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35810",
    "data-name": "Path 35810",
    d: "M172.775,199.66a9.615,9.615,0,0,1-1.736,5.527,12.2,12.2,0,0,1-1.463.088,13.515,13.515,0,0,1-2.306-.212,6.829,6.829,0,0,0-4.154-12.3,7.066,7.066,0,0,0-5.36,2.93,6.125,6.125,0,0,1-.283-1.927,7.9,7.9,0,0,1,.106-1.778A9.87,9.87,0,0,1,163.115,190,9.66,9.66,0,0,1,172.775,199.66Z",
    transform: "translate(-151.227 -187.217)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -8.75)",
    filter: "url(#Path_35811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35811-2",
    "data-name": "Path 35811",
    d: "M314.16,237.65l-1.058.418a.949.949,0,0,0-.534.534l-.418,1.058a.158.158,0,0,1-.294,0l-.418-1.058a.948.948,0,0,0-.534-.534l-1.058-.418a.158.158,0,0,1,0-.294l1.058-.418a.948.948,0,0,0,.534-.534l.418-1.058a.158.158,0,0,1,.294,0l.418,1.058a.948.948,0,0,0,.534.534l1.058.418A.158.158,0,0,1,314.16,237.65Z",
    transform: "translate(-294.24 -221.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_448",
    "data-name": "Mask Group 448",
    transform: "translate(6.311)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_180",
    "data-name": "Union 180",
    d: "M.908,9.725A.908.908,0,0,1,0,8.816a3.39,3.39,0,0,1,.057-.607l.007.017A3.474,3.474,0,0,1,.775,6.692L3.685,3.115a.763.763,0,0,0,.107-.8.673.673,0,0,0-.6-.431H3.153a1,1,0,0,0-.979,1.02.926.926,0,0,1-.908.945A.926.926,0,0,1,.36,2.907,2.856,2.856,0,0,1,3.153,0c.034,0,.063,0,.1,0a2.486,2.486,0,0,1,2.2,1.552,2.7,2.7,0,0,1-.382,2.779L2.16,7.911c-.011.011-.021.025-.031.039H5.042a.9.9,0,0,1,.764.434l.018-.028a.906.906,0,0,1-.781,1.369Z",
    transform: "translate(2.698 7.375)",
    fill: "url(#linear-gradient-6)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondPrize);
export default __webpack_public_path__ + "static/media/second-prize.42b24ebd3d789cb7f89e034c7ae1fd7e.svg";
export { ForwardRef as ReactComponent };